import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';

import type { TeamsCachingContext, TeamsContext } from './types';

interface TeamsContextStoreData {
  readonly teamsContext: TeamsContext | undefined;
  readonly teamsCachingContext: TeamsCachingContext;
}

type GetInitialState = () => TeamsContextStoreData;
export const getInitialState: GetInitialState = () => ({
  teamsContext: undefined,
  teamsCachingContext: {
    isCached: false,
  },
});

export interface TeamsContextStore extends TeamsContextStoreData {
  readonly setTeamsContext: (context: TeamsContext) => void;
  readonly setIsCached: (isCached: boolean) => void;
}

export const teamsContextStore = createStore<TeamsContextStore>((set) => ({
  ...getInitialState(),
  setTeamsContext: (context) => set((state) => ({ ...state, teamsContext: context })),
  setIsCached: (isCached) =>
    set((state) => ({
      ...state,
      teamsCachingContext: { ...state.teamsCachingContext, isCached },
    })),
}));

export const useTeamsContextStoreSelector = <T>(
  selector: (state: ReturnType<typeof teamsContextStore.getState>) => T
): T => useStore(teamsContextStore, selector);
